
const state = {
    // arrTab: [{ taburl: '/welcome', tabicon: 'el-icon-s-home', tabtitle: '首页' }],
    // activeName: '/welcome'

    arrTab: localStorage.getItem('tabs') ? JSON.parse(localStorage.getItem('tabs')) : [{ taburl: '/welcome', tabicon: 'el-icon-s-home', tabtitle: '首页' }],
    activeName: localStorage.getItem('active_tab') ? localStorage.getItem('active_tab') : '/welcome'

    // arrTab:  [{ taburl: '/welcome', tabicon: 'el-icon-s-home', tabtitle: '首页' }],
    // activeName:'/welcome'
}


//tabObj {'taburl':'welcome','tabicon':'el-icon-date','tabtitle':'欢迎'}

const mutations = {
    ADD_TAB: (state, tabObj) => {
        let result = state.arrTab.some(item => {
            if (item.taburl === tabObj.taburl)
                return true
        })
        if (result) {
            localStorage.setItem('active_tab', tabObj.taburl)
            state.activeName = tabObj.taburl
        } else {
            state.arrTab.push(tabObj)
            localStorage.setItem('tabs', JSON.stringify(state.arrTab))
            state.activeName = tabObj.taburl
            localStorage.setItem('active_tab', tabObj.taburl)
        }

    },
    REMOVE_TAB: (state, tabUrl) => {
        state.arrTab.some((item, i) => {
            if (item.taburl == tabUrl) {
                state.arrTab.splice(i, 1)
                return true
            }
        })
        localStorage.setItem('tabs', JSON.stringify(state.arrTab))
    },
    REMOVE_OTHER_TAB:(state, tabUrl) => {
        const curItem = state.arrTab.filter(item => {
            return item.taburl == tabUrl;
        })
        console.log('>>>>>>>>>>>>',curItem)
        curItem.unshift({ taburl: '/welcome', tabicon: 'el-icon-s-home', tabtitle: '首页' });
        state.arrTab = curItem;
        state.activeName = tabUrl;
        localStorage.setItem('tabs', JSON.stringify(curItem))
    },
    SET_ACTIVE_NAME: (state, newActiveName) => {
        state.activeName = newActiveName
        localStorage.setItem('active_tab', newActiveName)
    },
    CLEAR_TAB: (state) => {
        localStorage.removeItem('tabs')
        localStorage.removeItem('active_tab')
        state.arrTab = [{ taburl: '/welcome', tabicon: 'el-icon-s-home', tabtitle: '首页' }]
        state.activeName = '/welcome'
    }
}
const actions = {
    addTab({ commit }, tabObj) {
        return new Promise(resolve => {
            commit('ADD_TAB', tabObj)
            resolve()
        })
    },
    removeTab({ commit }, tabObj) {
        return new Promise(resolve => {
            commit('REMOVE_TAB', tabObj)
            resolve()
        })
    },
    setActiveName({ commit }, newActiveName) {
        return new Promise(resolve => {
            commit('SET_ACTIVE_NAME', newActiveName)
            resolve()
        })
    },
    clearTab({ commit }) {
        return new Promise(resolve => {
            commit('CLEAR_TAB')
            resolve()
        })
    },
    clearOtherTab({ commit }, tabUrl) {
        return new Promise(resolve => {
            commit('REMOVE_OTHER_TAB', tabUrl)
            resolve()
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}